import type { RootState } from '../store';

export const selectCurrentQuestion = (state: RootState) =>
  state.questionnaire.questions[state.questionnaire.currentQuestionIndex];
export const selectCurrentQuestionIndex = (state: RootState) =>
  state.questionnaire.currentQuestionIndex;
export const selectAnswers = (state: RootState) => state.questionnaire.answers;
